import { Component, input } from "@angular/core";

@Component({
    selector: 'instant-bottom-sheet',
    templateUrl: './instant-bottom-sheet.component.html',
    styleUrls: ['./instant-bottom-sheet.component.scss']
})
export class InstantBottomSheet {
  
  isDialogOpen = input.required<boolean>();
  
  constructor(
    ) {
  }
}
